import apiClient from './api'

export interface LoginRequest {
  email: string
  password: string
}

export interface RegisterRequest {
  email: string
  password: string
  firstName: string
  lastName: string
  companyName: string
  signupToken?: string
  discountCode?: string
}

export interface AcceptInvitationRequest {
  token: string
  firstName: string
  lastName: string
  password: string
}

export interface User {
  id: string
  tenantId: string
  email: string
  firstName: string
  lastName: string
  role: string
  isPlatformAdmin: boolean
}

export interface InvitationInfo {
  tenantId: string
  workspaceName: string
  companyName: string
  email: string
  role: string
  expiresAt: string
}

export interface AuthResponse {
  data: {
    user: User
    token: {
      access_token: string
      token_type: string
      expires_in: string
    }
  }
  meta: {
    timestamp: string
  }
}

export interface ProfileResponse {
  data: {
    user: User
  }
  meta: {
    timestamp: string
  }
}

export interface InvitationResponse {
  data: {
    invitation: InvitationInfo
  }
  meta: {
    timestamp: string
  }
}

export const authService = {
  register: (data: RegisterRequest) => apiClient.post<AuthResponse>('/auth/register', data),

  login: (data: LoginRequest) => apiClient.post<AuthResponse>('/auth/login', data),

  getProfile: () => apiClient.get<ProfileResponse>('/auth/profile'),

  verify: () => apiClient.get('/auth/verify'),

  getInvitation: (token: string) => apiClient.post<InvitationResponse>('/auth/invitations/lookup', { token }),

  acceptInvitation: (data: AcceptInvitationRequest) =>
    apiClient.post<AuthResponse>('/auth/invitations/accept', data),

  logout: () => {
    localStorage.removeItem('authToken')
    localStorage.removeItem('user')
  },
}
